import React from 'react';
import { Button } from 'Common/components/Atoms/Button';
import { Card } from 'Common/components/Atoms/Card';
import { Div } from 'Common/components/Atoms/Div';
import { Flex } from 'Common/components/Atoms/Flex';
import { FontIcon } from 'Common/components/Atoms/FontIcon';
import { Loading } from 'Common/components/Atoms/Loading';
import { useTheme } from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';
import { faChevronLeft } from '@fortawesome/pro-solid-svg-icons';

const useStyles = makeStyles(() => ({
  grow: {
    flexGrow: 1,
  },
  card: {
    borderRadius: '8px !important',
  },
  footer: {
    borderBottomRightRadius: '8px',
    borderBottomLeftRadius: '8px',
  },
}));

interface Props {
  children: React.ReactNode;
  showFooter: boolean;
  showPreviousButton: boolean;
  primaryButtonColor?: string;
  primaryButtonText?: string;
  previousStep?: () => void;
  handleSubmit: () => void;
  isUpdating: boolean;
}

export default function StepCard(props: Props): JSX.Element {
  const theme = useTheme();
  const classes = useStyles(theme);
  const {
    children,
    showFooter,
    showPreviousButton,
    primaryButtonColor,
    primaryButtonText,
    previousStep,
    handleSubmit,
    isUpdating,
  } = props;
  return (
    <Div className={classes.grow} mb={10} width="100%">
      <Card display="block" className={classes.card}>
        <Flex direction="column">
          <Div py={4} px={5} className={classes.grow}>
            {children}
          </Div>
          {showFooter && (
            <Flex
              justifyContent="space-between"
              alignItems="center"
              height={60}
              background={theme.palette.action.disabledBackground}
              px={5}
              className={classes.footer}
            >
              {showPreviousButton && (
                <Button
                  data-testid="qa-step-previous"
                  variant="text"
                  customcolor={theme.palette.text.secondary}
                  onClick={previousStep}
                >
                  <FontIcon icon={faChevronLeft} size="sm" mr={1} /> Previous
                </Button>
              )}
              <Button
                data-testid="qa-step-button"
                variant="contained"
                customcolor={primaryButtonColor || theme.palette.secondary.main}
                ml="auto"
                onClick={handleSubmit}
                width="100px"
              >
                {isUpdating ? (
                  <Loading size={24} />
                ) : (
                  primaryButtonText || 'Continue'
                )}
              </Button>
            </Flex>
          )}
        </Flex>
      </Card>
    </Div>
  );
}

StepCard.defaultProps = {
  showFooter: true,
  showPreviousButton: true,
};
